module.exports = __webpack_public_path__ + "img/ic_actual revenue_yellow.641aec42.svg";